import { Style } from 'index';

const ExtractionOutOfSyncStyles: Style = {
    banner: {
        backgroundColor: 'secondary.main',
        color: 'white',
        padding: '1rem',
        borderRadius: '4px',
        marginBottom: '1rem',
        position: 'sticky',
        top: '1.5rem',
        marginTop: '1rem',
        zIndex: 10,
    },
};

export default ExtractionOutOfSyncStyles;
